import PropTypes from 'prop-types';
import { Text, Spinner } from '@bevy/bevy-design-system';

import {
  BaseModal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ContainedButton,
  TextButton,
} from '@/shared/components/Modals';

export default function ConfirmModal({
  isOpen = false,
  onClose,
  closeOnClickOutside = true,
  size = 'medium',
  position = 'middle',
  modalTitle,
  modalBody,
  confirmText,
  cancelText,
  onCancel = onClose,
  disableCancel = false,
  disableConfirm = false,
  confirmLoading = false,
  onConfirm,
}) {
  return (
    <BaseModal
      isOpen={isOpen}
      onClose={onClose}
      closeOnClickOutside={closeOnClickOutside}
      size={size}
      position={position}
    >
      <ModalHeader>
        <Text variant='h4'>{modalTitle}</Text>
      </ModalHeader>
      <ModalBody>{modalBody}</ModalBody>
      <ModalFooter>
        <TextButton onClick={onCancel} ariaLabel={cancelText} disabled={disableCancel}>
          {cancelText}
        </TextButton>
        <ContainedButton onClick={onConfirm} ariaLabel={confirmText} disabled={disableConfirm}>
          {confirmText} {confirmLoading && <Spinner />}
        </ContainedButton>
      </ModalFooter>
    </BaseModal>
  );
}

ConfirmModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  modalTitle: PropTypes.string,
  modalBody: PropTypes.node,
  confirmText: PropTypes.string.isRequired,
  cancelText: PropTypes.string.isRequired,
  disableCancel: PropTypes.bool,
  disableConfirm: PropTypes.bool,
  confirmLoading: PropTypes.bool,
  closeOnClickOutside: PropTypes.bool,
  size: PropTypes.string,
  position: PropTypes.string,
};
